module.exports = "/_next/static/images/mh-5acc521d142f4536c7b9b280e4e6b385.svg";